<template>
    <div class="pa-0" v-if="liftmanager">
        <c-drawer-header
            v-resize   = "onResize"
            title      = "Clipboard"
            :subtitle  = "customer ? customer.name : null"
            icon       = "fas fa-inbox"
            :usefilter = "true"
            :usetoggle = true
            @close     = "onClose"
            @filter    = "onFilter"
            @toggle    = "onToggle"
            @arrow     = "onArrow"
        />
        <v-expand-transition>
            <div v-if="filter" class="filter-panel">
                <div class="mt-3 mb-3">
                    <v-text-field
                        v-model        = "searchtext"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        append-icon    = "fas fa-search"
                        clearable
                        hide-details
                    />
                </div>
            </div>
        </v-expand-transition>

        <div>
            <v-layout row wrap class="ml-3 mt-0 mr-1" :style="'height: ' + height + 'px'">
                <div v-if="!entries || entries.length === 0" class="inb-no-messages">
                    Clipboard hat keine Einträge
                </div>
                <v-container v-if="entries && entries.length > 0" fluid class="h-100 pa-0" style="width: calc(100% + 10px)">
                    <v-data-iterator
                        :items         = "entries"
                        :search        = "searchtext"
                        :custom-filter = "cfilter"
                        hide-default-footer
                        :items-per-page="100"
                        style="overflow-x: hidden; overflow-y: scroll; max-height: calc(100% - 1px)"
                    >
                        <template v-slot:default="props">
                            <c-inc-clipboard-entry
                                v-for="(item) in props.items"
                                :key   = "item.id"
                                :entry = "item"
                                class="mt-3 pr-2 pl-1"
                                @dragend = "onDragend"
                            />
                        </template>
                    </v-data-iterator>
                </v-container>
            </v-layout>
        </div>
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import Inb             from "@/modules/inb/service/Inb.js";
import CDrawerHeader   from "@/modules/core/components/utils/CDrawerHeader.vue";
import CIncClipboardEntry from "@/modules/inc/steps/components/common/clipboard/private/CIncClipboardEntry.vue";

export default {
    name: "CIncClipboardDrawer",

    components: {
        CIncClipboardEntry,
        CDrawerHeader,
    },

    data: () => ({
        menuOpen  : false,
        height    : null,
        filter    : false,
        customer  : null,
        searchtext: null,
        usecontext: false,
        right     : true,
        context   : {
            incident: null,
            site    : null
        }
    }),

    computed: {
        unit () {
            const site = this.$store.getters.site;
            if (!site) {
                return null;
            }

            return site;
        },

        entries () {
            return this.$store.getters.clipboard;
        },

        liftmanager() {
            return Core.role.liftmanager();
        },
    },

    created() {
        this.load();
    },

    watch: {
        unit () {
            this.initialize ();
        }
    },

    methods: {
        initialize () {
            if (!this.unit) {
                return;
            }

            if (!this.customer) {
                this.customer = this.unit.customer;
            }
        },

        onInsert () {

        },

        onFilter () {
            this.filter = !this.filter;
            this.onResize();
        },

        onToggle () {
            this.usecontext = !this.usecontext;
        },

        onArrow (value) {
            this.$emit("position", value);
        },

        onAcceptType () {
            return true;
        },

        onDrop (item) {
            Inb.detach(this, item.data.messageId);
        },

        onDragend (event) {
            this.$bus.$emit(this.$events.drag.end, event);
        },

        onRemove () {
            this.$emit("close");
        },

        onResize () {
            const d = this.filter ? 165 : 60;
            this.height = window.innerHeight - d;
        },

        onClose () {
            this.$emit("close");
        },

        load() {
            if (!this.unit) {
                return;
            }
        },

        cfilter (items, search) {
            return items.filter (entry => {
                if (!search) {
                    return true;
                }

                if (Core.filter.includes("" + entry.incidentId, search)) {
                    return true;
                }

                if (Core.filter.includes(entry.typeName, search)) {
                    return true;
                }

                if (Core.filter.includes(entry.unit.fabricNo, search)) {
                    return true;
                }

                if (Core.filter.includes(entry.unit.zip, search)) {
                    return true;
                }

                if (Core.filter.includes(entry.unit.city, search)) {
                    return true;
                }

                if (Core.filter.includes(entry.unit.street, search)) {
                    return true;
                }

                return false;
            });
        },
    }
}

</script>

<style scoped>

.inb-no-messages {
    text-align: center;
    padding-top: 20px;
    height: 65px;
    font-size: 18px;
}


.filter-panel {
    margin-left: 15px;
    margin-right: 20px;
    margin-top: 15px;
    padding: 10px 15px;
    border-style: solid;
    border-width: 1px;
    border-color: #0a68b8;
    border-radius: 5px;
}

</style>
